const BookingDataTypes = {
	SET_BOOKED_PROPERTIES: 'SET_BOOKED_PROPERTIES',
	FETCH_GUEST_BOOKED_START: 'FETCH_GUEST_BOOKED_START',
	FETCH_GUEST_BOOKED_SUCCESS: 'FETCH_GUEST_BOOKED_SUCCESS',
	FETCH_GUEST_BOOKED_FAILURE: 'FETCH_GUEST_BOOKED_FAILURE',
	FETCH_HOME_OWNERS_BOOKED_SUCCESS: 'FETCH_HOME_OWNERS_BOOKED_SUCCESS',
};

export default BookingDataTypes;
